/**
 * Created by Oleg on 19/12/18
 */

const SubscriptionWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.weekProduct = Product.CreateById("subsWeek");
        this.monthProduct = Product.CreateById("subsMonth");

        if (connector.platform.oneOf(connector.MICROSOFT) && cleverapps.config.debugMode) {
            this.weekProduct = Product.CreateById("subsWeekTest");
            this.monthProduct = Product.CreateById("subsMonthTest");
        }

        this._super({
            name: "SubscriptionWindow",
            content: this.createContent(),
            noBackground: true,
            title: Messages.get("SubscriptionWindow.Title"),
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SUBSCRIPTION_WINDOW_OPEN);
    },

    getPerson: function () {
        return !["merge", "merge2"].includes(cleverapps.config.type) && {
            role: "hero",
            emotion: "happy"
        };
    },

    buySubscription: function (product) {
        cleverapps.subscription.buy(product, this.createListener(() => {
            this.close();
        }));
    },

    createContent: function () {
        const styles = cleverapps.styles.SubscriptionWindow;
        const prizesView = this.prizesView = this.createRewardsList();

        const layoutItems = [];
        layoutItems.unshift(this.createFooter());

        layoutItems.unshift(new SubscriptionButtons({
            monthProduct: this.monthProduct,
            weekProduct: this.weekProduct,
            buySubscription: this.buySubscription.bind(this)
        }));

        layoutItems.unshift(new SubscriptionInfo());
        layoutItems.unshift(prizesView);

        const subtitle = cleverapps.UI.generateOnlyText(Messages.get("SubscriptionRewardsList.subtitle"), cleverapps.styles.FONTS.SUBSCRIPTION_PRIZE_SUBTITLE);
        subtitle.fitTo(styles.subtitle.width, styles.subtitle.height);
        layoutItems.unshift(subtitle);

        return new cleverapps.Layout(layoutItems, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    createFooter: function () {
        const terms = new Terms();
        const styles = cleverapps.styles.SubscriptionWindow;

        if (terms.width > 0.9 * styles.width) {
            terms.setScale(styles.width * 0.9 / terms.width);
        }

        let restore;

        if (!cleverapps.subscription.isActive() && connector.platform.oneOf(connector.IOS, connector.MACOS)) {
            restore = new Restore(this);
            restore.setScale(terms.getScale());
        }

        return new cleverapps.Layout([terms, restore], {
            direction: cleverapps.UI.VERTICAL
        });
    },

    onShow: function () {
        this._super();
        if (this.prizesView.showUp) {
            this.prizesView.showUp();
        }
    },

    createRewardsList: function () {
        const styles = cleverapps.overrideStyles(cleverapps.styles.RewardWindow.rewards, cleverapps.styles.SubscriptionWindow.rewards, true);
        return new RewardsListComponent(Subscription.CalcReward(), {
            font: cleverapps.styles.FONTS.REWARDWINDOW_VALUE_TEXT,
            iconWrap: styles.iconWrap,
            margin: styles.margin,
            textMargin: styles.textMargin,
            event: cleverapps.EVENTS.EARN.PURCHASE
        });
    },

    listBundles: function () {
        return ["subscription_window"];
    }
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    SUBSCRIPTION_WINDOW_GOLD_OFFER_STROKE: {
        color: new cc.Color(46, 83, 26, 255),
        size: 2
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    SUBSCRIPTION_PRIZE_SUBTITLE: {
        size: 48,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.SubscriptionWindow = {
    width: 600,
    margin: 15,
    padding: {
        top: 20
    },

    rewards: {
        margin: {
            y: 20
        },
        textMargin: -10
    },

    subtitle: {
        width: 600,
        height: 70
    }
};
